import * as React from 'react'
import styled, { css } from "styled-components"
import { Style } from "../../styles"

const Container = styled.div<{ open?: boolean }>`
  border: 1px solid ${Style.color.border};
  border-radius: 6px;
  transition: max-height 0.5 ease-in-out, box-shadow 0.5s ease-in-out;

  &:hover {
    box-shadow: 0px 4px 8px 0px rgba(20, 20, 20, 0.15);
  }
`

const Header = styled.h3`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  position: relative;
  padding: 16px;
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;

  svg {
    width: 16px;
    height: 16px;
  }
`

const Content = styled.div`
  padding: 12px;

`

interface IProps {
  title: string
  children: React.ReactNode
}

const Accordion = (props: IProps) => {
  const { title, children } = props
  const [open, setOpen] = React.useState(false)

  const toggleAccordion = () => {
    setOpen(!open)
  }

  return (
    <Container open={open}>
      <Header onClick={toggleAccordion}>
        {title}

        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M5.1499 11.9998C5.1499 11.7798 5.2299 11.5598 5.3999 11.3998L8.7999 7.99984L5.3999 4.59984C5.0699 4.26984 5.0699 3.72984 5.3999 3.39984C5.7299 3.06984 6.2699 3.06984 6.5999 3.39984L11.1999 7.99984L6.5999 12.5998C6.2699 12.9298 5.7299 12.9298 5.3999 12.5998C5.2299 12.4298 5.1499 12.2198 5.1499 11.9998Z"></path></svg>
      </Header>

      {open && <Content>
        {children}
      </Content>}
    </Container>
  )
}

export default Accordion